/**
 * Gifts main — category tabs swap card images/text (from gifts-main-page.html).
 * Scoped to [data-gifts-shop-category]; reads JSON from #gifts-category-{sectionId}.
 */
(function () {
  /**
   * @param {HTMLElement} root
   */
  function init(root) {
    if (!root || root.dataset.giftsCategoryInit === "1") {
      return;
    }
    root.dataset.giftsCategoryInit = "1";

    const sid = root.dataset.sectionId;
    if (!sid) {
      return;
    }

    const dataEl = document.getElementById(`gifts-category-${sid}`);
    if (!dataEl) {
      return;
    }

    /** @type {Record<string, unknown>} */
    let categoryData = {};
    try {
      categoryData = JSON.parse(dataEl.textContent || "{}");
    } catch {
      return;
    }

    const mainCard = root.querySelector('[data-gc="mainCard"]');
    const mainBadge = root.querySelector('[data-gc="mainBadge"]');
    const mainTitle = root.querySelector('[data-gc="mainTitle"]');
    const mainText = root.querySelector('[data-gc="mainText"]');
    const mainLink = root.querySelector('[data-gc="mainLink"]');

    const card2 = root.querySelector('[data-gc="card2"]');
    const card2Title = root.querySelector('[data-gc="card2Title"]');
    const card2Link = root.querySelector('[data-gc="card2Link"]');

    const card3 = root.querySelector('[data-gc="card3"]');
    const card3Title = root.querySelector('[data-gc="card3Title"]');
    const card3Link = root.querySelector('[data-gc="card3Link"]');

    const card4 = root.querySelector('[data-gc="card4"]');
    const card4Title = root.querySelector('[data-gc="card4Title"]');
    const card4Link = root.querySelector('[data-gc="card4Link"]');

    if (
      !mainCard ||
      !mainBadge ||
      !mainTitle ||
      !mainText ||
      !mainLink ||
      !card2 ||
      !card2Title ||
      !card2Link ||
      !card3 ||
      !card3Title ||
      !card3Link ||
      !card4 ||
      !card4Title ||
      !card4Link
    ) {
      return;
    }

    /**
     * @param {string} tabName
     */
    function updateCategory(tabName) {
      const data = categoryData[tabName];
      if (!data || typeof data !== "object") {
        return;
      }

      const main = /** @type {{ badge?: string; title?: string; text?: string; link?: string; image?: string }} */ (
        /** @type {Record<string, unknown>} */ (data).main || {}
      );
      const top = /** @type {{ title?: string; link?: string; image?: string }} */ (
        /** @type {Record<string, unknown>} */ (data).top || {}
      );
      const bottomLeft = /** @type {{ title?: string; link?: string; image?: string }} */ (
        /** @type {Record<string, unknown>} */ (data).bottomLeft || {}
      );
      const bottomRight = /** @type {{ title?: string; link?: string; image?: string }} */ (
        /** @type {Record<string, unknown>} */ (data).bottomRight || {}
      );

      mainBadge.textContent = main.badge || "";
      mainTitle.textContent = main.title || "";
      mainText.textContent = main.text || "";
      mainLink.setAttribute("href", main.link || "#");
      if (main.image) {
        mainCard.style.backgroundImage = `url("${main.image}")`;
      } else {
        mainCard.style.removeProperty("background-image");
      }

      card2Title.textContent = top.title || "";
      card2Link.setAttribute("href", top.link || "#");
      if (top.image) {
        card2.style.backgroundImage = `url("${top.image}")`;
      } else {
        card2.style.removeProperty("background-image");
      }

      card3Title.textContent = bottomLeft.title || "";
      card3Link.setAttribute("href", bottomLeft.link || "#");
      if (bottomLeft.image) {
        card3.style.backgroundImage = `url("${bottomLeft.image}")`;
      } else {
        card3.style.removeProperty("background-image");
      }

      card4Title.textContent = bottomRight.title || "";
      card4Link.setAttribute("href", bottomRight.link || "#");
      if (bottomRight.image) {
        card4.style.backgroundImage = `url("${bottomRight.image}")`;
      } else {
        card4.style.removeProperty("background-image");
      }
    }

    const tabs = root.querySelectorAll(".category-tab");
    for (const tab of tabs) {
      tab.addEventListener("click", () => {
        for (const btn of tabs) {
          btn.classList.remove("active");
        }
        tab.classList.add("active");
        tab.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
        const selectedTab = tab.getAttribute("data-tab");
        if (selectedTab) {
          updateCategory(selectedTab);
        }
      });
    }

    const defaultTab = root.dataset.defaultTab || "occasion";
    updateCategory(defaultTab);
    for (const tab of tabs) {
      if (tab.getAttribute("data-tab") === defaultTab) {
        tab.classList.add("active");
      } else {
        tab.classList.remove("active");
      }
    }
  }

  function boot() {
    document.querySelectorAll("[data-gifts-shop-category]").forEach(init);
  }

  if (document.readyState === "complete") {
    window.requestAnimationFrame(boot);
  } else {
    window.addEventListener("load", boot);
  }

  document.addEventListener("shopify:section:load", (ev) => {
    const t = ev.target;
    if (!(t instanceof HTMLElement)) {
      return;
    }
    const inner = t.querySelector("[data-gifts-shop-category]");
    if (inner) {
      inner.dataset.giftsCategoryInit = "";
      init(inner);
    }
  });
})();
